import React from 'react';

import MoviesBySearchComponent from "../components/MoviesBySearch/MoviesBySearchComponent";

const SearchPage = () => {

    return (
        <div>
            <MoviesBySearchComponent/>
        </div>
    );
};

export {SearchPage};